import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormTabs,
  title: 'Form Tabs',
  category: ComponentCategory.FormControls,
  droppable: false,
};
